import React from 'react';
import classNames from 'classnames';
import Select, { underlinerFunc } from 'ui/select';

import Data from 'data';
import Locale from 'data/locale';
import Store from 'store';
import NumberInput from 'ui/number';
import { profileSetClass, profileSetDifficulty, profileSetMerc, profileUpdateAttributes } from 'logic/stateReducers';
import GameContext from 'gamectx';

const _L = Locale("ui-classes");

const diffNames = [5156, 5155, 5154];
const mercNames = {
  '0': () => Data.info.patch ? Locale.strings.strhirespecial1 : `${Locale.strings.strhirespecial1} (${Locale.istrings[diffNames[0]]})`,
  '1': () => Data.info.patch ? Locale.strings.strhirespecial2 : `${Locale.strings.strhirespecial2} (${Locale.istrings[diffNames[0]]})`,
  '2': () => Data.info.patch ? Locale.strings.strhirespecial1 : `${Locale.strings.strhirespecial1} (${Locale.istrings[diffNames[1]]})`,
  '3': () => Data.info.patch ? Locale.strings.strhirespecial2 : `${Locale.strings.strhirespecial2} (${Locale.istrings[diffNames[1]]})`,
  '5': () => Data.info.patch ? Locale.strings.strhirespecial1 : `${Locale.strings.strhirespecial2} (${Locale.istrings[diffNames[2]]})`,
  '4': () => Data.info.patch ? Locale.strings.strhirespecial2 : `${Locale.strings.strhirespecial1} (${Locale.istrings[diffNames[2]]})`,

  '6': () => `${Locale.strings.PalMercEXST4X} (${Data.info.patch ? Locale.strings.skillname99 : Locale.istrings[diffNames[0]]})`,
  '7': () => `${Locale.strings.PalMercExST1X} (${Data.info.patch ? Locale.strings.skillname104 : Locale.istrings[diffNames[0]]})`,
  '8': () => `${Locale.strings.PalMercEXST3X} (${Data.info.patch ? Locale.strings.skillname108 : Locale.istrings[diffNames[0]]})`,
  '9': () => `${Locale.strings.PalMercEXST4X} (${Data.info.patch ? Locale.strings.skillname103 : Locale.istrings[diffNames[1]]})`,
  '10': () => `${Locale.strings.PalMercExST1X} (${Data.info.patch ? Locale.strings.skillname114 : Locale.istrings[diffNames[1]]})`,
  '11': () => `${Locale.strings.PalMercEXST3X} (${Data.info.patch ? Locale.strings.skillname98 : Locale.istrings[diffNames[1]]})`,
  '12': () => `${Locale.strings.PalMercEXST4X} (${Data.info.patch ? Locale.strings.skillname99 : Locale.istrings[diffNames[2]]})`,
  '13': () => `${Locale.strings.PalMercExST1X} (${Data.info.patch ? Locale.strings.skillname104 : Locale.istrings[diffNames[2]]})`,
  '14': () => `${Locale.strings.PalMercEXST3X} (${Data.info.patch ? Locale.strings.skillname108 : Locale.istrings[diffNames[2]]})`,

  '15': () => Data.info.patch ? Locale.strings.strhirespecial7 : `${Locale.strings.strhirespecial7} (${Locale.istrings[diffNames[0]]})`,
  '16': () => Data.info.patch ? Locale.strings.strhirespecial6 : `${Locale.strings.strhirespecial6} (${Locale.istrings[diffNames[0]]})`,
  '17': () => Data.info.patch ? Locale.strings.strhirespecial5 : `${Locale.strings.strhirespecial5} (${Locale.istrings[diffNames[0]]})`,
  '18': () => Data.info.patch ? Locale.strings.strhirespecial7 : `${Locale.strings.strhirespecial7} (${Locale.istrings[diffNames[1]]})`,
  '19': () => Data.info.patch ? Locale.strings.strhirespecial6 : `${Locale.strings.strhirespecial6} (${Locale.istrings[diffNames[1]]})`,
  '20': () => Data.info.patch ? Locale.strings.strhirespecial5 : `${Locale.strings.strhirespecial5} (${Locale.istrings[diffNames[1]]})`,
  '21': () => Data.info.patch ? Locale.strings.strhirespecial7 : `${Locale.strings.strhirespecial7} (${Locale.istrings[diffNames[2]]})`,
  '22': () => Data.info.patch ? Locale.strings.strhirespecial6 : `${Locale.strings.strhirespecial6} (${Locale.istrings[diffNames[2]]})`,
  '23': () => Data.info.patch ? Locale.strings.strhirespecial5 : `${Locale.strings.strhirespecial5} (${Locale.istrings[diffNames[2]]})`,

  '24': () => Data.info.patch ? Locale.strings.skillname126 : `${Locale.strings.skillname126} (${Locale.istrings[diffNames[0]]})`,
  '36': () => Data.info.patch ? Locale.strings.skillname147 : `${Locale.strings.skillname147} (${Locale.istrings[diffNames[0]]})`,
  '26': () => Data.info.patch ? Locale.strings.skillname126 : `${Locale.strings.skillname126} (${Locale.istrings[diffNames[1]]})`,
  '37': () => Data.info.patch ? Locale.strings.skillname147 : `${Locale.strings.skillname147} (${Locale.istrings[diffNames[1]]})`,
  '28': () => Data.info.patch ? Locale.strings.skillname126 : `${Locale.strings.skillname126} (${Locale.istrings[diffNames[2]]})`,
  '38': () => Data.info.patch ? Locale.strings.skillname147 : `${Locale.strings.skillname147} (${Locale.istrings[diffNames[2]]})`,
};
const mercOptions = () => [
  {id: '', name: _L`No mercenary`},
  {
    title: '1',
    options: (Data.info.patch ? [0, 1] : [0, 1, 2, 3, 4, 5]).map(i => ({id: i.toString(), name: mercNames[i]()})),
  },
  {
    title: '2',
    options: (Data.info.patch ? [6, 7, 8, 9, 10, 11] : [6, 7, 8, 9, 10, 11, 12, 13, 14]).map(i => ({id: i.toString(), name: mercNames[i]()})),
  },
  {
    title: '3',
    options: (Data.info.patch ? [15, 16, 17] : [15, 16, 17, 18, 19, 20, 21, 22, 23]).map(i => ({id: i.toString(), name: mercNames[i]()})),
  },
  {
    title: '5',
    options: (Data.info.patch ? [24, 36] : [24, 36, 26, 37, 28, 38]).map(i => ({id: i.toString(), name: mercNames[i]()})),
  },
];
const mercValue = i => {
  i = parseInt(i);
  if (i >= 0 && i <= 5) return {id: i.toString(), name: `Act I ${mercNames[i]()}`, icon: 'act1'};
  if (i >= 6 && i <= 14) return {id: i.toString(), name: `Act II ${mercNames[i]()}`, icon: 'act2'};
  if (i >= 15 && i <= 23) return {id: i.toString(), name: `Act III ${mercNames[i]()}`, icon: 'act3'};
  if (i === 24 || i === 26 || i === 28) return {id: i.toString(), name: `Act V ${mercNames[i]()}`, icon: 'act5'};
  if (i === 36 || i === 38 || i === 38) return {id: i.toString(), name: `Act V ${mercNames[i]()}`, icon: 'act5'};
  return {id: '', name: _L`No mercenary`};
};

const classValue = cls => ({ id: cls, name: Locale.strings[Data.classNames[cls]] || Data.classNames[cls]});
const diffValue = idx => ({ id: idx, name: Locale.istrings[diffNames[idx]]});

const renderValue = ({id, name}, search) => <span><span className={`d2p-class-icon d2p-class-${id}`}/>{search ? underlinerFunc(name, search) : name}</span>;

function MenuBorders() {
  const gameCtx = React.useContext(GameContext);
  if (gameCtx.name === 'd2r') return null;
  return <>
    <div className="d2p-menu-left"/>
    <div className="d2p-menu-top"/>
    <div className="d2p-menu-right"/>
    <div className="d2p-menu-bottom"/>
    <div className="d2p-menu-corner d2p-menu-tl"/>
    <div className="d2p-menu-corner d2p-menu-tr"/>
    <div className="d2p-menu-corner d2p-menu-bl"/>
    <div className="d2p-menu-corner d2p-menu-br"/>
  </>;
};

const WrappedInput = ({ wrapClass, disabled, ...props }) => (
  <div className={classNames("d2p-input-box", wrapClass, {"d2p-disabled": disabled})}>
    <div className="d2p-input-left"/>
    <div className="d2p-input-middle"/>
    <div className="d2p-input-right"/>
    <NumberInput {...props} disabled={disabled}/>
  </div>
);

const SelectMenu = props => (
  <Select {...props}>
    <div className="d2p-input-left"/>
    <div className="d2p-input-middle"/>
    <div className="d2p-input-right"/>
  </Select>
);

export const ClassSelect = React.memo(function ClassSelect({ disabled }) {
  const charClass = Store.useProfile(profile => profile.class);
  const charLevel = Store.useProfile(profile => profile.level);
  const charDifficulty = Store.useProfile(profile => profile.difficulty);

  const dispatch = Store.useDispatch();
  const onChangeClass = React.useCallback(value => dispatch.setProfile((profile, state) => profileSetClass(profile, value.id, state)), [dispatch]);
  const onChangeDifficulty = React.useCallback(value => dispatch.setProfile(profile => profileSetDifficulty(profile, value.id)), [dispatch]);
  const onChangeLevel = React.useCallback(value => dispatch.setProfile(profile => {
    if (profile.level === value) return profile;
    profile = {...profile, level: value};
    profile.mercLevel = Math.max(2, Math.min(profile.mercLevel, value, 98));
    return profileUpdateAttributes(profile);
  }), [dispatch]);
  
  const classOptions = React.useMemo(() => Data.classes.map(classValue), []);
  const diffOptions = React.useMemo(() => [0, 1, 2].map(diffValue), []);

  return (
    <div className="d2p-ClassBar">
      <SelectMenu className="d2p-ClassSelect d2p-class"
              renderValue={renderValue}
              renderOption={renderValue}
              options={classOptions}
              value={classValue(charClass)}
              onChange={onChangeClass}
              menuBefore={<MenuBorders/>}
              renderArrow={() => <span className="d2p-arrow"/>}
              disabled={disabled}
      />
      <span className="d2p-separator"/>
      <WrappedInput wrapClass="d2p-level" digits={0} value={charLevel} onChange={onChangeLevel} min={1} max={99} disabled={disabled} onlyFinal/>
      <span className="d2p-separator"/>
      <SelectMenu className="d2p-right-side d2p-difficulty"
              options={diffOptions}
              value={diffValue(charDifficulty)}
              onChange={onChangeDifficulty}
              menuBefore={<MenuBorders/>}
              renderArrow={() => <span className="d2p-arrow"/>}
              disabled={disabled}
      />
    </div>
  );
});

const renderMercValue = ({id, name, icon}, search) => <span>{!!icon && <span className={`d2p-class-icon d2p-class-${icon}`}/>}{search ? underlinerFunc(name, search) : name}</span>;
const mercGroups = {
  '1': () => _L`Act I ${_L`Rogue Scout`}`,
  '2': () => _L`Act II ${_L`Desert Mercenary`}`,
  '3': () => _L`Act III ${_L`Eastern Sorceror`}`,
  '5': () => _L`Act V ${_L`Barbarian`}`,
};
const renderMercHeader = name => <span><span className={`d2p-class-icon d2p-class-act${name}`}/>{mercGroups[name]()}</span>;

export const MercSelect = React.memo(function MercSelect({ disabled }) {
  const mercClass = Store.useProfile(profile => profile.merc);
  const mercLevel = Store.useProfile(profile => profile.mercLevel);
  const mercMaxLevel = Store.useProfile(profile => Math.max(2, Math.min(profile.level, 98)));
  const mercMinLevel = 2;

  const dispatch = Store.useDispatch();
  const onChangeClass = React.useCallback(value => dispatch.setProfile((profile, state) => profileSetMerc(profile, value.id, state)), [dispatch]);
  const onChangeLevel = React.useCallback(value => dispatch.setProfile(profile => {
    value = Math.max(Math.min(value, profile.level, 98), 2);
    if (profile.mercLevel === value) return profile;
    return {...profile, mercLevel: value};
  }), [dispatch]);
  
  return (
    <div className="d2p-ClassBar">
      <SelectMenu className="d2p-ClassSelect d2p-merc-class"
              renderValue={renderMercValue}
              renderHeader={renderMercHeader}
              options={mercOptions}
              value={mercValue(mercClass)}
              onChange={onChangeClass}
              menuBefore={<MenuBorders/>}
              renderArrow={() => <span className="d2p-arrow"/>}
              disabled={disabled}
      />
      <span className="d2p-separator"/>
      <WrappedInput wrapClass="d2p-level" digits={0} value={mercLevel} onChange={onChangeLevel} min={mercMinLevel} max={mercMaxLevel} disabled={!mercClass || disabled} onlyFinal/>
    </div>
  );
});
